import * as React from 'react';
import { TextInput, TextInputProps } from '@mantine/core';

const WicketTextInput = React.forwardRef<HTMLInputElement, TextInputProps>((props, ref) => (
  <TextInput {...props} className="wik-text-input" ref={ref} />
));

WicketTextInput.displayName = 'WicketTextInput';

export default WicketTextInput;
